(function($, App, Utils, Components) {
  'use strict';

  Components.create('ConfirmModal', {
    Selectors: {
      ConfirmModal : '.confirm-modal',
      OpenConfirmModal: '.js-open-confirm-modal',
      CloseConfirmModal: '.js-close-confirm-modal',
      ConfirmConfirmBtn: '.js-confirm-btn'
    },
    bindEvents: function() {

      const $modal =  $(Components.ConfirmModal.Selectors.ConfirmModal),
            $btnOpenModal = $(Components.ConfirmModal.Selectors.OpenConfirmModal),
            confirmUrl = $btnOpenModal.data('url');

      $btnOpenModal.on('click', function(event){

        $modal.trigger('click');

        $(Components.ConfirmModal.Selectors.CloseConfirmModal).on('click', () => {
          vex.closeAll();
        })

        $(Components.ConfirmModal.Selectors.ConfirmConfirmBtn).on('click', () => {
          window.location.href = confirmUrl;
        })

      })

    },
    init: function() {
      this.bindEvents();
    }
  });
})(jQuery, window.App, window.App.Utils, window.App.Components);


